import { bootstrap } from '../../apps/product-comparison-summary/ProductComparisonSummaryApp';
import type { CreateProductComparisonSummaryOptions } from '../models/CreateProductComparisonSummaryOptions';
/**
 * Create a Brilliant summary table to compare products.
 */
export function createProductComparisonSummary(
    options: CreateProductComparisonSummaryOptions
): void {
    const { productIds, parent, title } = options;
    if (!productIds || productIds.length === 0) {
        throw new Error(
            'Brilliant: productIds are required to create a comparison summary table of products.'
        );
    }
    bootstrap(parent, productIds, title);
}
